import React, {useContext, useEffect, useState} from 'react'
import {useHistory} from 'react-router-dom'
import classnames from 'classnames'
import {AppContext, forceAppUpdate} from '../app/app'
import Config from '../launch/config'
import {_setIsSelectingShips} from '../app/app'
import ToolbarMenu from './toolbar-menu'
import handleBuildShipClick from './build-ship-click'
import handleColonizeClick from './colonize-click'
import handleDisbandClick from './disband-click'
import handleInfoClick from './info-click'
import handleMineClick from './mine-click'
import {deselectAllShips} from '../ship/utils'
import audio from '../launch/audio'

import menuImg from './img/bars.png'
import pauseImg from './img/pause.png'
import playImg from './img/play.png'
import mapMarkerImg from './img/map-marker.png'
import colonizeImg from './img/flag-white.png'
import disbandImg from './img/disband-white.png'
import homeImg from './img/home.png'
import feedbackImg from './img/feedback.png'
import shipImg from './img/ship-white.png'
import satelliteImg from './img/satellite-white.png'
import resourcesImg from './img/resources-white.png'
import infoImg from './img/info.png'
import muteImg from './img/mute.png'
import unmuteImg from './img/unmute.png'
import selectShipsImg from './img/select-ships.png'
import zoomInImg from './img/zoom-in.png'
import zoomOutImg from './img/zoom-out.png'
import compassImg from './img/compass.png'

import './toolbar.css'

const Toolbar = () => {
    const {
        hamburgerIsOpen,
        isGameLoading,
        isGameOver,
        isModalOpen,
        isMuted,
        isPaused,
        isSelectingShips,
        lastSelectedShipId,
        minimapOpen,
        modalContentType,
        selectedEntityId,
        selectedShipIds,
        selectedTowableId,
        setHamburgerIsOpen,
        setIsMuted,
        setMinimapOpen,
        setModalContentType,
        toggleGameOverOverlay,
        toggleModal,
        togglePaused,
    } = useContext(AppContext)
    const [satelliteCount, setSatelliteCount] = useState(0)
    const history = useHistory()

    const difficulty = Config.difficultyLevels[Config.difficulty]
    const entity = Config.entities[selectedEntityId]
    const ship = Config.ships[lastSelectedShipId]
    const towable = Config.towables[selectedTowableId]
    const friendlyShips = Object.keys(Config.ships).filter((key) => {
        const ship = Config.ships[key]

        return (
            ship.faction === Config.userFactionName && ship.type !== 'satellite'
        )
    })
    const shipIsSelected = Object.keys(selectedShipIds).length > 0
    const towableIsSelected = !!towable?.isSelected
    const entityIsSelected = !!entity?.selected
    const cameras = Config.scene.cameras
    const cam = cameras?.main

    useEffect(() => {
        if (!entity) {
            return
        }

        const count = Object.keys(entity.orbitingShips).filter(
            (key) => entity.orbitingShips[key].type === 'satellite'
        ).length

        setSatelliteCount(count)
    }, [entity])

    const genericBtnAction = (args) => {
        audio.buttonClick()
        _setIsSelectingShips(false)
        toggleModal(false)
        setHamburgerIsOpen(false)

        if (entityIsSelected) {
            entity.selected = false
        }
        if (towableIsSelected) {
            towable.isSelected = false
        }
    }

    const closeMinimap = () => {
        if (minimapOpen) {
            setMinimapOpen(false)
            Config?.minimap?.hide()
        }
    }

    const handleCompassClick = () => {
        deselectAllShips()

        if (entity) {
            entity.deselect()
        }

        toggleGameOverOverlay(false)
        setModalContentType('compass')
        toggleModal()
    }

    const isFriendlyPlanet =
        entity?.colonized && entity?.faction === Config.userFactionName

    const hasFriendlyOrbitingShip =
        entity &&
        Object.keys(entity.orbitingShips).find((key) => {
            const ship = Config.ships[key]

            return (
                ship?.type !== 'satellite' &&
                ship?.faction === Config.userFactionName
            )
        })

    const hasEnemyOrbitingShip =
        entity &&
        Object.keys(entity.orbitingShips).find((key) => {
            const ship = Config.ships[key]

            return ship?.faction === Config.enemyFactionName
        })

    const showInfoButton =
        entity?.selected ||
        (ship && Object.keys(selectedShipIds).length === 1) ||
        towable?.isSelected

    const showColonizeButton =
        !isGameOver &&
        hasFriendlyOrbitingShip &&
        entity?.selected &&
        entity?.type === 'planet' &&
        !isFriendlyPlanet

    const showMineResourcesButton =
        !isGameOver &&
        entity?.selected &&
        entity?.type === 'planet' &&
        !entity?.isMiningResources &&
        isFriendlyPlanet

    const showBuildShipButton =
        !isGameOver &&
        entity?.selected &&
        entity?.faction === Config.userFactionName

    const showDisbandButton =
        ship && !isGameOver && Object.keys(selectedShipIds).length > 0

    const satelliteButtonDisabled =
        entity?.isBuildingMine ||
        entity?.isBuildingShip ||
        Config.gameStats.resources < difficulty.satelliteResourceCost ||
        satelliteCount >= Config.satelliteMax

    const infoClick = () =>
        handleInfoClick({
            entity,
            selectedShipIds,
            setModalContentType,
            ship,
            toggleGameOverOverlay,
            toggleModal,
            towable,
        })

    if (isGameLoading || isPaused) {
        return null
    }

    return (
        <div className="toolbar">
            {shipIsSelected ? (
                <ToolbarMenu
                    id="ship"
                    items={[
                        {
                            image: infoImg,
                            label: 'Details',
                            onClick: () => {
                                genericBtnAction()
                                infoClick()
                            },
                            hidden: !showInfoButton,
                            disabled: false,
                        },
                        {
                            image: disbandImg,
                            label: 'Disband',
                            onClick: () => {
                                genericBtnAction()
                                handleDisbandClick()
                            },
                            amount:
                                ship?.type === 'satellite'
                                    ? difficulty.satelliteResourceDisbandSalvage
                                    : difficulty.shipResourceDisbandSalvage,
                            positive: true,
                            hidden: !showDisbandButton,
                            disabled: false,
                        },
                    ]}
                />
            ) : null}
            {towableIsSelected ? (
                <ToolbarMenu
                    id="towable"
                    items={[
                        {
                            id: 'details',
                            image: infoImg,
                            label: 'Details',
                            onClick: () => {
                                genericBtnAction()
                                infoClick()
                            },
                            hidden: false,
                            disabled: false,
                        },
                    ]}
                />
            ) : null}
            {entityIsSelected ? (
                <ToolbarMenu
                    id="entity"
                    items={[
                        {
                            image: infoImg,
                            label: 'Details',
                            onClick: () => {
                                genericBtnAction()
                                infoClick()
                            },
                            hidden: false,
                            disabled: false,
                        },
                        {
                            image: colonizeImg,
                            label: 'Colonize',
                            onClick: () => {
                                genericBtnAction()
                                handleColonizeClick(entity)
                            },
                            amount: difficulty.planetResourceBonus,
                            positive: true,
                            hidden: !showColonizeButton,
                            disabled:
                                entity?.isColonizing || hasEnemyOrbitingShip,
                        },
                        {
                            image: shipImg,
                            iconClassName: 'toolbar__icon--ship',
                            label: 'Build Ship',
                            onClick: () => {
                                genericBtnAction()
                                handleBuildShipClick(entity)
                            },
                            amount: difficulty.shipResourceCost,
                            hidden: !showBuildShipButton,
                            disabled:
                                entity?.isBuildingMine ||
                                entity?.isBuildingShip ||
                                Config.gameStats.resources <
                                    difficulty.shipResourceCost ||
                                friendlyShips.length >= Config.shipMax,
                        },
                        {
                            image: satelliteImg,
                            label: 'Build Satellite',
                            onClick: () => {
                                genericBtnAction()
                                const isSatellite = true
                                handleBuildShipClick(entity, isSatellite)
                                setSatelliteCount(satelliteCount + 1)
                            },
                            amount: difficulty.satelliteResourceCost,
                            hidden: !showBuildShipButton,
                            disabled: satelliteButtonDisabled,
                        },
                        {
                            image: resourcesImg,
                            label: 'Mine Resources',
                            onClick: () => {
                                genericBtnAction()
                                handleMineClick(entity)
                            },
                            amount: difficulty.planetMineResourceCost,
                            hidden: !showMineResourcesButton,
                            disabled:
                                entity?.isBuildingMine ||
                                entity?.isBuildingShip ||
                                Config.gameStats.resources <
                                    difficulty.planetMineResourceCost,
                        },
                    ]}
                />
            ) : null}

            {hamburgerIsOpen ? (
                <ToolbarMenu
                    id="main"
                    items={[
                        {
                            image: homeImg,
                            label: 'Main Menu',
                            onClick: () => {
                                genericBtnAction()
                                history.push('starbase')
                            },
                            hidden: false,
                            disabled: false,
                        },
                        {
                            image: isMuted ? muteImg : unmuteImg,
                            label: 'Mute',
                            onClick: () => {
                                genericBtnAction()
                                if (isPaused) {
                                    return
                                }
                                setIsMuted(!isMuted)
                            },
                            hidden: false,
                            disabled: false,
                        },
                        {
                            image: feedbackImg,
                            label: 'Provide Feedback',
                            onClick: () => {
                                genericBtnAction()
                                window.open(
                                    'https://docs.google.com/forms/d/e/1FAIpQLSefvVxczFDNc2C_oLjlOVDcOTdFTrCHYEavpu4kWp4X7Jrwwg/viewform?usp=sf_link'
                                )
                            },
                            hidden: false,
                            disabled: false,
                        },
                    ]}
                />
            ) : null}

            <button
                className={classnames('toolbar__button', {
                    'toolbar__button--active': hamburgerIsOpen,
                })}
                onClick={() => {
                    genericBtnAction()
                    deselectAllShips()
                    closeMinimap()
                    setHamburgerIsOpen(!hamburgerIsOpen)
                }}
            >
                <img
                    className="toolbar__icon toolbar__icon--hamburger"
                    src={menuImg}
                    alt="menu"
                />
            </button>

            <button
                className={classnames('toolbar__button', {
                    'toolbar__button--active':
                        isModalOpen && modalContentType === 'compass',
                })}
                onClick={() => {
                    genericBtnAction()
                    handleCompassClick()
                    closeMinimap()
                }}
            >
                <img className="toolbar__icon" src={compassImg} alt="compass" />
            </button>

            <button
                className={classnames('toolbar__button', {
                    'toolbar__button--active': minimapOpen,
                })}
                onClick={() => {
                    if (isPaused) {
                        return
                    }
                    genericBtnAction({isMini: true})
                    setMinimapOpen(!minimapOpen)

                    if (
                        !Config.scene.cameras.cameras.find(
                            ({name}) => name === 'mini'
                        )
                    ) {
                        Config.minimap.show()
                    } else {
                        Config?.minimap?.hide()
                    }
                }}
            >
                <img className="toolbar__icon" src={mapMarkerImg} alt="map" />
            </button>

            <button
                className={classnames('toolbar__button', {
                    'toolbar__button--active': isSelectingShips,
                })}
                onClick={() => {
                    genericBtnAction()
                    closeMinimap()
                    if (isPaused) {
                        return
                    }
                    deselectAllShips()
                    _setIsSelectingShips(!isSelectingShips)
                }}
            >
                <img
                    className="toolbar__icon"
                    src={selectShipsImg}
                    alt="select"
                />
            </button>

            <button
                className={classnames('toolbar__button', {
                    'toolbar__button--disabled': !(cam.zoom < Config.zoomMax),
                })}
                disabled={cam.zoom >= Config.zoomMax}
                onClick={() => {
                    genericBtnAction()
                    closeMinimap()
                    if (cam.zoom < Config.zoomMax) {
                        // cam.zoom += Config.zoomStep
                        cam.zoomTo(
                            (cam.zoom += Config.zoomStep),
                            0,
                            'Linear',
                            true
                        )
                    }
                    forceAppUpdate()
                }}
            >
                <img className="toolbar__icon" src={zoomInImg} alt="zoom in" />
            </button>

            <button
                className="toolbar__button"
                disabled={cam.zoom <= Config.zoomMin}
                onClick={() => {
                    genericBtnAction()
                    closeMinimap()
                    if (cam.zoom > Config.zoomMin) {
                        // cam.zoom -= Config.zoomStep
                        cam.zoomTo(
                            (cam.zoom -= Config.zoomStep),
                            0,
                            'Linear',
                            true
                        )
                    }
                    forceAppUpdate()
                }}
            >
                <img
                    className="toolbar__icon"
                    src={zoomOutImg}
                    alt="zoom out"
                />
            </button>

            <button
                className={classnames('toolbar__button', {
                    'toolbar__button--active': isPaused,
                })}
                onClick={() => {
                    genericBtnAction()
                    closeMinimap()
                    Config.scene.game.scene.pause('default')
                    togglePaused(!isPaused)
                    toggleModal(false)
                    isPaused && Config.scene.game.scene.resume('default')
                }}
            >
                <img
                    className="toolbar__icon"
                    src={isPaused ? playImg : pauseImg}
                    alt="pause/play"
                />
            </button>
        </div>
    )
}

export default Toolbar
